import { unaVez } from "../eventos";
import formulario from "../formulario";
var popup = function (dataLayer) {
    formulario('.popup .formulario', dataLayer);
    [].forEach.call(document.querySelectorAll('.popup'), function (popup) {
        if (popup.id && localStorage.getItem("popup-".concat(popup.id))) {
            popup.remove();
            return;
        }
        var elementoConFoco;
        var retardo = parseInt(popup.getAttribute('data-retardo') || '0'), cierra = function () {
            if (popup.id) {
                localStorage.setItem("popup-".concat(popup.id), (new Date()).toISOString());
            }
            popup.setAttribute('aria-hidden', 'true');
            unaVez(popup, 'transitionend', function () { return popup.remove(); });
            elementoConFoco === null || elementoConFoco === void 0 ? void 0 : elementoConFoco.focus();
        };
        setTimeout(function () {
            var _a;
            elementoConFoco = document.activeElement;
            popup.setAttribute('aria-hidden', 'false');
            (_a = popup.querySelector('input, a')) === null || _a === void 0 ? void 0 : _a.focus();
        }, retardo);
        popup.addEventListener('click', function (e) {
            var target = e.target;
            if (target === popup || target.closest('.popup__cerrar') || target.closest('.popup__boton--cerrar')) {
                cierra();
            }
        });
    });
};
export default popup;
